// src/utils/errors.ts
var InvalidUrlError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidUrlError";
  }
};
var InvalidStringError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidStringError";
  }
};
var EmptyStringError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "EmptyStringError";
  }
};
var UndefinedOrNullError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "UndefinedOrNullError";
  }
};
var StringOutOfRangeError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StringOutOfRangeError";
  }
};
var NonceError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "NonceError";
  }
};
var CsrfError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CsrfError";
  }
};
var InvalidHttpTokenResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidHttpTokenResponseError";
  }
};
var InvalidURLSearchParamsError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidURLSearchParamsError";
  }
};
var MissingSearchCodeParamError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "MissingSearchCodeParamError";
  }
};
var MissingSearchStateParamError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "MissingSearchStateParamError";
  }
};
var AuthCodeNotFoundError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthCodeNotFoundError";
  }
};
var CsrfNotFoundError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CsrfNotFoundError";
  }
};
var GetProfileResponseError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "GetProfileResponseError";
  }
};
var DecodeJwtError = class _DecodeJwtError extends Error {
  constructor(message) {
    super(message);
    this.name = "DecodeJwtError";
    Error.captureStackTrace(this, _DecodeJwtError);
  }
};
var JwtValidationError = class _JwtValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = "JwtValidationError";
    Error.captureStackTrace(this, _JwtValidationError);
  }
};
var StatusCode1xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode1xxError";
  }
};
var StatusCode3xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode3xxError";
  }
};
var StatusCode4xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode4xxError";
  }
};
var StatusCode5xxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "StatusCode5xxError";
  }
};
var EnvironmentNotGivenError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "EnvironmentNotGivenError";
  }
};

export {
  InvalidUrlError,
  InvalidStringError,
  EmptyStringError,
  UndefinedOrNullError,
  StringOutOfRangeError,
  NonceError,
  CsrfError,
  InvalidHttpTokenResponseError,
  InvalidURLSearchParamsError,
  MissingSearchCodeParamError,
  MissingSearchStateParamError,
  AuthCodeNotFoundError,
  CsrfNotFoundError,
  GetProfileResponseError,
  DecodeJwtError,
  JwtValidationError,
  StatusCode1xxError,
  StatusCode3xxError,
  StatusCode4xxError,
  StatusCode5xxError,
  EnvironmentNotGivenError
};
